export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_02.b9b95cd1.jpg";